import React, { useCallback, useEffect, useState } from "react";
import {
  Select,
  Form,
  Button,
  Table,
  Space,
  Modal,
  DatePicker,
  message,
} from "antd";
import { SearchOutlined, RedoOutlined } from "@ant-design/icons";
import { store } from "@root/store";
import { getProvinceBatch, updateProvinceBatch } from "@root/common/service";
import type { ColumnsType } from "antd/es/table";
import moment from "moment";
import "../_style.scss";

const { Option } = Select;
interface DataType {
  key: string;
  id: number | string;
  year: number | string;
  batchNumber: number;
  batchId: number;
  beginTime: string;
  endTime: string;
  // number: number|string;
  provicneName: string;
  provicneCode: string;
  instituteId: number | string;
}

function ProvinceSet(props: any) {
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [dataSource, setDataSource] = useState<DataType[]>();
  const [isSetTimeVisible, setIsSetTimeVisible] = useState(false);
  const [provinceArr, setProvinceArr] = useState<any>([]);
  const [timeItem, setTimeItem] = useState({
    id: "",
    provicneName: "",
    beginTime: "",
    endTime: "",
  });
  const [nowYear, setNowYear] = useState<number>(2022);
  const [batch, setBatch] = useState<number>(1);

  const columns: ColumnsType<DataType> = [
    {
      title: "序号",
      // dataIndex: 'number',
      // key: 'number',
      render: (text, record, index) => `${index + 1}`,
    },
    {
      title: "省份",
      dataIndex: "provicneName",
      key: "provicneName",
      render: (_, e) => (
        <Button
          style={{ padding: "0" }}
          onClick={() => setCounty(e)}
          type="link"
        >
          {e.provicneName}
        </Button>
      ),
    },
    {
      title: "年度",
      dataIndex: "year",
      key: "year",
    },
    {
      title: "批次",
      dataIndex: "batchNumber",
      key: "batchNumber",
    },
    {
      title: "开始日期",
      dataIndex: "beginTime",
      key: "beginTime",
    },
    {
      title: "截止日期",
      dataIndex: "endTime",
      key: "endTime",
    },
    {
      title: "操作",
      dataIndex: "set",
      key: "set",
      render: (_, e) => (
        <Space size="middle">
          <Button
            style={{ padding: "0" }}
            onClick={() => setTime(e)}
            type="link"
          >
            设置时间
          </Button>
        </Space>
      ),
    },
  ];

  const getAll = async () => {
    const { rows } = await getProvinceBatch({
      year: 2022,
      batch: 2,
      province: "",
      pageNum: 2,
      pageSize: 10,
    });
    console.log(rows);
    rows.forEach((item: any) => {
      item.key = item.id;
    });
    setDataSource(rows);
  };
  useEffect(() => {
    const date = new Date();
    setNowYear(date.getFullYear());
    setBatch(1);
    setProvinceArr(store.getState().directionaries.chinaProvinceData);
    getAll();
  }, []);

  const setTime = useCallback(
    (e: any) => {
      console.log("setTime", e);
      setTimeItem(e);
      form2.setFieldsValue({
        startDate: moment(e.beginTime, "YYYY-MM-DD"),
        endDate: moment(e.endTime, "YYYY-MM-DD"),
      });
      setIsSetTimeVisible(true);
    },
    [form2]
  );
  const setCounty = useCallback(
    (e: any) => {
      console.log("setCounty", e);
      props.setKey("3");
      props.setProId(e.provicneCode);
    },
    [props]
  );

  const setTimeCancel = useCallback((e: any) => {
    setIsSetTimeVisible(false);
  }, []);

  const handleChange = useCallback((e: any, a: any) => {
    console.log("选择结果", e, a);
    // setTimeItem(e)
  }, []);

  const onFinish = useCallback((e: any) => {
    console.log("onFinish", e);
    const getOne = async () => {
      const { rows } = await getProvinceBatch({
        year: e.year === undefined ? "2022" : e.year,
        batch: e.batch === undefined ? "" : e.batch,
        province: e.province === undefined ? "" : e.province,
      });
      console.log(rows);
      setDataSource(rows);
    };
    getOne();
  }, []);
  const setTimeFinish = useCallback(
    (e: any) => {
      console.log("setTimeFinish", e, timeItem);
      const setOne = async () => {
        const { code, msg } = await updateProvinceBatch({
          id: timeItem.id,
          beginTime: moment(e.startDate).format("YYYY-MM-DD HH:mm:ss"),
          endTime: moment(e.endDate).format("YYYY-MM-DD HH:mm:ss"),
        });
        if (code === 200) {
          message.success("更新成功");
          getAll();
        } else {
          message.error(`更新失败,${msg}`);
        }
      };
      setOne();
      getAll();
      setIsSetTimeVisible(false);
    },
    [timeItem]
  );
  const onFinishFailed = useCallback(() => {
    console.log("onFinishFailed验证未通过");
  }, []);
  const onReset = useCallback(() => {
    form1.resetFields();
    getAll();
  }, [form1]);

  return (
    <>
      <div className="proBtn">
        <Form
          name="provinceSet"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="inline"
          form={form1}
        >
          <Form.Item label="年度" name="year">
            <Select
              placeholder="请选择年度"
              onChange={handleChange}
              allowClear
              style={{ width: 120 }}
            >
              <Option value={nowYear}>{nowYear}</Option>
            </Select>
          </Form.Item>

          <Form.Item label="批次" name="batch">
            <Select
              placeholder="请选择批次"
              onChange={handleChange}
              allowClear
              style={{ width: 120 }}
            >
              <Option value={batch}>{batch}</Option>
            </Select>
          </Form.Item>

          <Form.Item label="省份" name="province">
            <Select
              placeholder="请选择省份"
              onChange={handleChange}
              allowClear
              style={{ width: 120 }}
            >
              {provinceArr.map((e: any, i: number) => {
                return (
                  <Option value={e.value} key={i}>
                    {e.label}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>

          <Form.Item style={{ marginLeft: "30px" }}>
            <Button type="primary" htmlType="submit">
              查询
            </Button>
            <Button
              type="primary"
              onClick={onReset}
              style={{ marginLeft: "15px" }}
            >
              重置
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="boxTable">
        <Table
          dataSource={dataSource}
          columns={columns}
          bordered
          scroll={{ y: "calc(100vh - 250px)" }}
        />
      </div>
      <Modal
        title="设置时间"
        visible={isSetTimeVisible}
        onCancel={setTimeCancel}
        footer={[]}
        width="650px"
      >
        省份：{timeItem.provicneName}
        <Form
          name="provinceSet"
          onFinish={setTimeFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          style={{ marginTop: "15px" }}
          layout="inline"
          initialValues={{
            startDate: moment(timeItem.beginTime, "YYYY-MM-DD"),
            endDate: moment(timeItem.endTime, "YYYY-MM-DD"),
          }}
          form={form2}
        >
          <Form.Item
            label="开始日期"
            name="startDate"
            rules={[
              { required: true, message: "开始时间不可为空，请正确选择!" },
            ]}
          >
            <DatePicker disabled onChange={handleChange} />
          </Form.Item>

          <Form.Item
            label="结束日期"
            name="endDate"
            rules={[
              { required: true, message: "结束时间不可为空，请正确选择!" },
            ]}
          >
            <DatePicker onChange={handleChange} />
          </Form.Item>

          <Form.Item
            style={{
              display: "flex",
              marginTop: "15px",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <Button onClick={setTimeCancel} style={{ marginRight: "15px" }}>
              取消
            </Button>
            <Button type="primary" htmlType="submit">
              保存
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default ProvinceSet;
